export default __webpack_public_path__ + "static/media/dm.0410ad20.svg";